// extracted by mini-css-extract-plugin
export var infoRow = "_ub-2";
export var labelContainer = "_ub-0";
export var rightInfo = "_ub-1";